import axios from 'axios';

export default async function declineShuttleMission(baseUrl, payload){
  try{
    const res = await axios.post(`${baseUrl}/admin/declineShuttleMission`, payload);
    return res.data || res;
  }catch(e){
    return 'error';
  }
}
